import Immutable from 'immutable';
const LOAD = 'caredelta/LOAD';
const LOAD_SUCCESS = 'caredelta/LOAD_SUCCESS';
const LOAD_FAIL = 'caredelta/LOAD_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  billingData: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('isFutureLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('billingData', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('billingData', null);

    default:
      return state;
  }
};


export const getBillingData = (params='') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');

  params.abbr = user.UdaDrList.abbr;
  params.userId = user.UdaDrList.userId;

  if(params) {
    params = JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/api/care-delta/${params}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const sendReport = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post('udr/care-delta/sendReport', {data:reportObj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
